import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { CallStateEnum } from '@models/call-state.model.ts';
import { TableState } from '@store/table-store/table.model.ts';

export type HandleClose = () => void;

export interface ProductCategoriesActionParams {
  data?: any;
  id?: number;
  state?: TableState;
  handleClose?: HandleClose;
}

export interface ProductCategoriesState extends CallStateMethods {
  callState: CallStateEnum;
  departmentUnit: any[];
  getDepartmentUnit: () => Promise<void>;
  createProductCategories: (params: ProductCategoriesActionParams) => void;
  editProductCategories: (params: ProductCategoriesActionParams) => void;
  deleteProductCategories: (params: ProductCategoriesActionParams) => void;
}

interface ProductCategoriesStateMethods extends CallStateMethodNames {
  createProductCategories: 'createProductCategories';
  editProductCategories: 'editProductCategories';
  deleteProductCategories: 'deleteProductCategories';
  getDepartmentUnit: 'getDepartmentUnit';
}

export const PRODUCT_CATEGORIES_INITIAL_STATE: Omit<
  ProductCategoriesState,
  keyof ProductCategoriesStateMethods
> = {
  callState: CallStateEnum.Init,
  departmentUnit: []
};
